// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phsa-order-calculation__color--calculated{color:#0077b2}.phsa-order-calculation__color--phsa-order{color:#f44336}", ""]);
// Exports
module.exports = exports;
